import ReactBreadcrumb from "@/components/breadcrumb/Breadcrumb";
import { useFetchDataV2 } from "@/hooks/useFetchDataV2";
import DataTableCommercial from "@/project-owner/components/DataTableCommercial";
import Filter from "@/project-owner/components/Filter";
import ProjectListCard from "@/project-owner/components/ProjectListCard";
import { Program, Project } from "@/types/pp";
import { VisibilityState } from "@tanstack/react-table";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

const ProjectOwner = () => {
  const [projectsData, setProjectsData] = useState<Project[]>([]);
  const [projectsFiltered, setProjectsFiltered] = useState([]);
  const { idPp, firstname } = useParams();
  const actions = "";
  const currentCarrier = 1;
  const noSwitch = false;
  const [loadingProjectsFiltered, setLoadingProjectsFiltered] = useState(false);
  const { data } = useFetchDataV2<Project[]>(
    `${import.meta.env.VITE_API_ENDPOINT}/financer/projects`,
    `projects`,
    1000 * 60 * 60
  );

  useEffect(() => {
    if (data && data.length) {
      if (idPp) {
        const filteredData = data.filter(
          (item) => item.program.carrier.id === parseInt(idPp)
        );
        setProjectsData(filteredData);
      } else {
        setProjectsData(data);
      }
    }
  }, [data, idPp]);
  // State pour les projets filtrés

  // Calcul dynamique de projectsByPp basé sur projectsFiltered
  const projectsByPp = useMemo(() => {
    return projectsFiltered.reduce(
      (
        acc: Record<string, { program: Program; projects: Project[] }>,
        project: Project
      ) => {
        const ppId = project.program.carrier.id;
        if (!acc[ppId]) {
          acc[ppId] = {
            program: project.program,
            projects: [],
          };
        }
        acc[ppId].projects.push(project);
        return acc;
      },
      {}
    );
  }, [projectsFiltered, projectsData]);
  const [view, setView] = React.useState("card");
  const [defaultOpened, setDefaultOpened] = useState([]);

  const defaultVisibility: VisibilityState = {
    status: true,
    sold: true,
    typology: true,
    program: true,
    country: true,
    contributions: true,
    contributionCall: true,
    isFunded: true,
    projectOwner: false,
    launchDate: false,
    treesPlanted: false,
    regeneratedArea: false,
    CO2Sequestre: false,
    vegetationCover: false,
    jobCreation: false,
  };
  const [columnVisibility, setColumnVisibility] =
    React.useState<VisibilityState>(defaultVisibility);
  const { t } = useTranslation("dashboard", {
    keyPrefix: "dashboard",
  });
  const items = [
    {
      href: `/${firstname}`,
      name: t("Tableau de bord"),
    },
  ];
  if (idPp && Object.values(projectsByPp)?.length > 0) {
    items.push({
      href: "",
      name: Object.values(projectsByPp)[0].program.carrier.fullname,
    });
  } else {
    items.push({
      href: "",
      name: t("Porteur de projet"),
    });
  }
  return (
    <div className="mb-20 md:mb-0">
      <div className="mb-5">
        <ReactBreadcrumb items={items} isTruncated={false} />
      </div>
      <h1 className="text-3xl font-bold mb-5">
        {idPp && Object.values(projectsByPp)?.length > 0
          ? Object.values(projectsByPp)[0].program.carrier.fullname
          : t("Porteur de projet")}
      </h1>
      <Filter
        projects={projectsData}
        projectsByPp={projectsByPp}
        setProjectsFiltered={setProjectsFiltered} // Permet de mettre à jour les projets filtrés
        view={view}
        setView={setView}
        defaultOpened={defaultOpened}
        setDefaultOpened={setDefaultOpened}
        noSwitch={noSwitch}
        currentCarrier={currentCarrier}
        columnVisibility={columnVisibility}
        setColumnVisibility={setColumnVisibility}
        setLoadingProjectsFiltered={setLoadingProjectsFiltered}
      />
      {view == "list" ? (
        <DataTableCommercial
          setProjects={setProjectsData}
          projectsByPp={projectsByPp}
          defaultOpened={defaultOpened}
          setDefaultOpened={setDefaultOpened}
          columnVisibility={columnVisibility}
          setColumnVisibility={setColumnVisibility}
          loadingProjectsFiltered={loadingProjectsFiltered}
        />
      ) : (
        <ProjectListCard projects={projectsFiltered} actions={actions} />
      )}
    </div>
  );
};
export default ProjectOwner;
